import { ActionField, ActionPlanAction, FieldValue } from "src/api/client-api/ActionPlan/ActionPlanAction";
import { SsqProperty } from "src/api/sure-api/actions/useGetOneAction";
import { isFieldStartingDataInsufficient } from "../../../EditProperties/ImpactSection/utils";
import { GetOnePost } from "src/api/client-api/post/useGetOnePost";
import { ActionSubproperty } from "./formatMultivalue";

type Options = {
    actionFields: ActionField[];
    actionPlanAction: ActionPlanAction;
    fieldValues: FieldValue[] | undefined;
    position: number;
    startingPost: GetOnePost | undefined;
    subproperties: SsqProperty[];
};

export const getActionFieldByMultiElement = (options: Options): ActionSubproperty[] => {
    const { actionFields, actionPlanAction, fieldValues, position, startingPost, subproperties } = options;
    const subpropertiesByPosition: ActionSubproperty[] = subproperties.flatMap((multivalueSubproperty) => {
        const ssqPropertyId = multivalueSubproperty.id;
        const foundActionField = actionFields.find((actField) => {
            const isActFieldValid = actField.actionFormulas?.some((formula) => {
                const doesContainPropertyId = formula.targetSsqProperty?.id === ssqPropertyId;
                return doesContainPropertyId;
            });
            return isActFieldValid;
        });

        if (foundActionField === undefined) {
            return [];
        }

        const disabled = isFieldStartingDataInsufficient(foundActionField, actionPlanAction);

        const fieldValue = fieldValues?.find((v) => {
            const isField = v.actionFieldId === foundActionField.id;
            const isRightPosition = v.position === position;
            return isField && isRightPosition;
        });

        const unit = multivalueSubproperty.unit?.abbreviation;

        const startingValue = getStartingValue({
            position,
            startingPost,
            subproperty: multivalueSubproperty,
            unit,
        });

        const { hidden, question, dataList } = foundActionField;
        const dataListOptions = dataList?.options;
        const fieldType = foundActionField.field?.type ?? "text";

        const actionSubproperty: ActionSubproperty = {
            fieldValue,
            hidden,
            question,
            dataListOptions,
            fieldType,
            disabled,
            unit,
            ssqPropertyId,
            position: position,
            actionFieldId: foundActionField.id,
            startingValue: {
                label: startingPost?.campaign?.label,
                value: startingValue.value,
                unit: startingValue.unit,
            },
        };

        return [actionSubproperty];
    });
    return subpropertiesByPosition;
};

type Options2 = {
    position: number;
    startingPost: GetOnePost | undefined;
    subproperty: SsqProperty;
    unit: string | undefined;
};
const getStartingValue = (opts: Options2) => {
    const { position, startingPost, subproperty, unit } = opts;

    const _startingValue = startingPost?.elements?.find((elem) => {
        return elem.ssqPropertyId === subproperty.id && elem.position === position;
    });

    const datalistTypes = ["radio", "select", "checkbox"];
    const pType = subproperty.field?.type;
    if (pType && datalistTypes.includes(pType)) {
        const previousValueLabel = subproperty.dataList?.options.find((datalist) => {
            return datalist.value === _startingValue?.value && datalist.position === _startingValue.position;
        });
        const startingValueOption: StartingValue = {
            value: previousValueLabel?.label,

            // When we use an option, no unit should be here
            unit: undefined,
        };
        return startingValueOption;
    }

    const startingValue: StartingValue = {
        value: _startingValue?.value,
        unit,
    };
    return startingValue;
};
type StartingValue = {
    value: string | undefined;
    unit: string | undefined;
};
